import { BTabs } from './tabs';
import { BTab } from './tab';
import { pluginFactory } from '../../utils/plugins';
var TabsPlugin =
/*#__PURE__*/
pluginFactory({
  components: {
    BTabs: BTabs,
    BTab: BTab
  }
});
export { TabsPlugin, BTabs, BTab };


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/components/tabs/index.js
// module id = ./node_modules/bootstrap-vue/esm/components/tabs/index.js
// module chunks = 1